import React from 'react';
import {BaseInputProps} from '../..';
import styled from 'styled-components';

export interface CustomInputProps<T = any> extends BaseInputProps<T> {
  component: React.ReactNode;
}

const CustomInput: React.FC<CustomInputProps> = ({component}) => {
  return <Wrapper>{component}</Wrapper>;
};

export default CustomInput;

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
  focused?: boolean;
}

export const Wrapper = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
`;
